export default {
  GENERAL: 'general',
  PARAMETERS: 'parameters',
  CHART: 'chart',
};
